export const FEATURE_NAME = '@vshosting/cdn/features/delete-domain-dialog';
